import {IntermediatePart} from "../../intermediatePart";

export default class LeftWall extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'left_wall';
    this.partName = 'Left Wall';
    this.translateId = "visualizer.kitchen.walls.left_wall";
    this.activeFeatureBeforeAllWalls = null;
    this.allWallsApplied = true;
    this.isStoneFeature = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new LeftWall());
  }

  setZIndex(zIndexes) {
    if(zIndexes) {
      const zIndex = zIndexes.Walls.LeftWall;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndex;
      }
    }
  }
}
